import React, { useState } from "react";
import { useParams } from "react-router-dom";
import products from "../data/flowerVendors";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { CartContext } from "../context/CartContext";

export default function ProductDetails() {
  const { id } = useParams();
  const product = products.find((p) => p.id === parseInt(id));
  const [selectedLengthIdx, setSelectedLengthIdx] = useState(0);
  const [selectedColorIdx, setSelectedColorIdx] = useState(0);
  const { addToCart } = useContext(CartContext);

  // safety guard
  if (!product) {
    return (
      <main className="max-w-[1280px] mx-auto px-6 py-8">
        <p className="text-center text-xl">Product not found.</p>
      </main>
    );
  }

  const mainImage = product.imgVariants?.[0] || "/logo192.png";
  const thumbs = product.imgVariants?.slice(1, 5) || [];
  const vendorAvatar =
    "https://lh3.googleusercontent.com/aida-public/AB6AXuA-5FKBnOzYkM43volrxnIB3CjIfUqGrKIKqur7XwApRmFsmLDdgl7ivwOtgzeiQA5zFI191vl8PF0_YHaOsoICrj3dhzQlpxnQ64ZDdW7_hj3CLuoDXwP-erWxsczMEUFE_p9MSmeLaycPc9NrY-5vEWxAxDyLX6qZe1OMSVRqEewrNlxsrkeZNK3qEPEmHOjOqaYDifiIEaecy4CrQyysI0tX3m_j9PYueGaibEdISo433FF09UIoGhKCdfYl5FSNC8ZH6qY1zE5s";
  // dynamic length options (optional)
  const dynamicLengths = product.dynamicLength && product.dynamicLength.length ? product.dynamicLength : null;
  

  // compute price based on selected length option. Support several shapes:
  // - string: no price change
  // - { label, priceDelta }
  // - { label, delta }
  const basePrice = Number(product.starting_price || product.price || 0);
  const selectedLength = dynamicLengths ? dynamicLengths[selectedLengthIdx] : null;
  const priceDelta = selectedLength && typeof selectedLength === 'object'
    ? (Number(selectedLength.priceDelta ?? selectedLength.delta ?? selectedLength.add ?? 0) || 0)
    : 0;
  const displayedPrice = (basePrice + priceDelta).toFixed(2);

  return (
    <main className="max-w-[1280px] mx-auto px-6 py-8">
      <nav className="flex items-center gap-2 text-sm font-medium text-[#9a8d4c] mb-8">
        <a className="hover:text-primary" href="#">
          Home
        </a>
        <span className="material-symbols-outlined text-sm">chevron_right</span>
        <a className="hover:text-primary" href="#">
          Wedding Services
        </a>
        <span className="material-symbols-outlined text-sm">chevron_right</span>
        <span className="text-background-dark dark:text-white">{product.name}</span>
      </nav>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
        <div className="lg:col-span-7 space-y-4">
          <div className="aspect-[4/5] rounded-2xl overflow-hidden bg-[#e7e3cf] shadow-xl">
            <img alt="Product Main Image" className="w-full h-full object-cover" src={mainImage} />
          </div>

          <div className="grid grid-cols-4 gap-4">
            {thumbs.length === 0 ? (
              <div className="aspect-square rounded-xl overflow-hidden cursor-pointer">
                <img alt="Thumb" className="w-full h-full object-cover" src={mainImage} />
              </div>
            ) : (
              thumbs.map((src, idx) => (
                <div
                  key={idx}
                  className={`aspect-square rounded-xl overflow-hidden cursor-pointer ${idx === 0 ? 'ring-2 ring-primary' : 'hover:ring-2 hover:ring-primary/50'} transition-all`}
                >
                  <img alt={`Thumb ${idx + 1}`} className="w-full h-full object-cover hover:opacity-80 transition-opacity" src={src} />
                </div>
              ))
            )}

            {/* If there are more images, show a +n tile */}
            {product.imgVariants && product.imgVariants.length > 5 && (
              <div className="aspect-square rounded-xl overflow-hidden cursor-pointer relative group">
                <img alt="More" className="w-full h-full object-cover" src={product.imgVariants[4]} />
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center text-white font-bold group-hover:bg-black/20 transition-all">
                  +{product.imgVariants.length - 4}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="lg:col-span-5 flex flex-col">
          <div className="mb-2">
            {product.bestSeller && (
              <span className="inline-flex items-center gap-1 px-3 py-1 bg-primary/10 text-[#9a8d4c] text-xs font-bold rounded-full uppercase tracking-widest border border-primary/20">
                Bestseller
              </span>
            )}
          </div>

          <h1 className="text-4xl font-black tracking-tight mb-4">{product.name}</h1>

          <div className="flex items-center gap-4 mb-6">
            <div className="flex items-center gap-1 text-primary">
              <span className="material-symbols-outlined !text-xl">star</span>
              <span className="material-symbols-outlined !text-xl">star</span>
              <span className="material-symbols-outlined !text-xl">star</span>
              <span className="material-symbols-outlined !text-xl">star</span>
              <span className="material-symbols-outlined !text-xl">star_half</span>
            </div>
            <span className="text-sm font-bold text-[#9a8d4c]">{product.rating ?? '4.9'} ({product.reviews ?? 124} Verified Reviews)</span>
          </div>

          <div className="mb-8">
            <span className="text-3xl font-black">${displayedPrice}</span>
            <span className="text-[#9a8d4c] text-sm font-medium ml-2">{product.priceNote || 'Per Pair (Set of 2)'}</span>
          </div>

          <div className="space-y-6 pb-8 border-b border-[#e7e3cf] dark:border-[#3d3a2a]">
            <div>
              <h3 className="text-sm font-bold uppercase tracking-wider mb-3">Floral Composition</h3>
              <div className="flex flex-wrap gap-2">
                {(product.floralComposition || ['Premium Ooty Roses','Madurai Malligai (Jasmine)','Golden Thai Lilies','Fresh Tulsi Springs']).map((c, i) => (
                  <span key={i} className="px-3 py-1.5 bg-[#f3f1e7] dark:bg-[#3d3a2a] rounded-lg text-xs font-semibold">{c}</span>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-3">
                <label className="text-sm font-bold uppercase tracking-wider">Garland Length</label>
                {dynamicLengths ? (
                  <select
                    value={selectedLengthIdx}
                    onChange={(e) => setSelectedLengthIdx(Number(e.target.value))}
                    className="w-full bg-transparent border-[#e7e3cf] dark:border-[#3d3a2a] rounded-xl focus:ring-primary focus:border-primary text-sm font-medium"
                  >
                    {dynamicLengths.map((opt, i) => {
                      const label = typeof opt === 'string' ? opt : (opt.label || opt.name || `Option ${i + 1}`);
                      const delta = typeof opt === 'object' ? Number(opt.priceDelta ?? opt.delta ?? opt.add ?? 0) : 0;
                      return (
                        <option key={i} value={i}>
                          {label}{delta ? ` (+$${delta.toFixed(2)})` : ''}
                        </option>
                      );
                    })}
                  </select>
                ) : (
                  <select className="w-full bg-transparent border-[#e7e3cf] dark:border-[#3d3a2a] rounded-xl focus:ring-primary focus:border-primary text-sm font-medium">
                    <option>Standard (5.5 ft)</option>
                    <option>Extended (6.5 ft) +$40</option>
                    <option>Royal Grandeur (8 ft) +$90</option>
                  </select>
                )}
              </div>
              <div className="space-y-3">
                <label className="text-sm font-bold uppercase tracking-wider">Color Theme</label>
                <div className="flex gap-3 mt-1">
                  <button className="size-8 rounded-full bg-red-600 border-2 border-white ring-2 ring-primary" />
                  <button className="size-8 rounded-full bg-pink-400 border-2 border-white hover:ring-2 hover:ring-primary/40" />
                  <button className="size-8 rounded-full bg-yellow-400 border-2 border-white hover:ring-2 hover:ring-primary/40" />
                  <button className="size-8 rounded-full bg-white border-2 border-gray-200 hover:ring-2 hover:ring-primary/40" />
                </div>
              </div>
            </div>
          </div>

          <div className="py-8 space-y-4">
            <button
              className="w-full bg-primary text-background-dark py-4 rounded-xl font-black text-lg shadow-lg hover:brightness-105 transition-all flex items-center justify-center gap-2"
              onClick={() => {
                // Build a cart item that includes selected options
                const lengthLabel = dynamicLengths
                  ? (typeof selectedLength === 'string' ? selectedLength : (selectedLength?.label || selectedLength?.name || null))
                  : null;
                let colorLabel = null;
                if (product.colorTheme && product.colorTheme.length) {
                  const c = product.colorTheme[selectedColorIdx];
                  colorLabel = typeof c === 'string' ? c : (c?.label || c?.name || c?.color || null);
                }

                addToCart({ ...product, selectedLength: lengthLabel, selectedColor: colorLabel });
              }}
            >
              <span className="material-symbols-outlined">shopping_bag</span> Add to Cart
            </button>
            <button className="w-full bg-transparent border border-[#e7e3cf] dark:border-[#3d3a2a] py-4 rounded-xl font-bold text-lg hover:bg-white dark:hover:bg-[#3d3a2a] transition-all">Custom Request &amp; Inquiries</button>
          </div>

          <div className="mt-4 p-6 bg-white dark:bg-[#2d2a1b] rounded-2xl border border-[#e7e3cf] dark:border-[#3d3a2a] shadow-sm">
            <div className="flex items-center gap-4 mb-4">
              <div className="size-16 rounded-full bg-cover bg-center border-2 border-primary/20" style={{ backgroundImage: `url("${vendorAvatar}")` }} />
              <div>
                <h4 className="font-bold text-lg">{product.vendor?.name || 'Sri Vasavi Florals'}</h4>
                <p className="text-xs font-semibold text-green-600 flex items-center gap-1">
                  <span className="material-symbols-outlined !text-xs">verified</span>
                  Master Artisan
                </p>
              </div>
              <a className="ml-auto text-primary text-sm font-bold hover:underline" href="#">View Profile</a>
            </div>
            <p className="text-sm text-[#9a8d4c] leading-relaxed line-clamp-2 italic">{product.vendor?.blurb || 'Specializing in temple-style intricate weaving for over 15 years. Every garland is handmade on the day of delivery.'}</p>
          </div>
        </div>
      </div>

      <section className="grid grid-cols-1 lg:grid-cols-3 gap-8 py-12 border-y border-[#e7e3cf] dark:border-[#3d3a2a] mb-16">
        <div className="flex gap-4">
          <div className="size-12 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
            <span className="material-symbols-outlined text-primary">local_shipping</span>
          </div>
          <div>
            <h4 className="font-bold mb-1">Same-Day Hyperlocal Delivery</h4>
            <p className="text-sm text-[#9a8d4c]">Delivered within 4 hours of completion across Bangalore Urban. Temperature controlled transport.</p>
          </div>
        </div>
        <div className="flex gap-4">
          <div className="size-12 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
            <span className="material-symbols-outlined text-primary">eco</span>
          </div>
          <div>
            <h4 className="font-bold mb-1">Ethically Sourced Flowers</h4>
            <p className="text-sm text-[#9a8d4c]">Direct from Madurai and Ooty flower markets. Supporting local small-scale floral farmers.</p>
          </div>
        </div>
        <div className="flex gap-4">
          <div className="size-12 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
            <span className="material-symbols-outlined text-primary">verified_user</span>
          </div>
          <div>
            <h4 className="font-bold mb-1">Quality Assurance</h4>
            <p className="text-sm text-[#9a8d4c]">Photo confirmation of your actual garland sent before dispatch for 100% satisfaction.</p>
          </div>
        </div>
      </section>

      <section className="mb-20">
        <div className="flex items-center justify-between mb-8">
          <h3 className="text-2xl font-extrabold tracking-tight">More from {product.vendor?.name || 'Sri Vasavi Florals'}</h3>
          <div className="flex gap-2">
            <button className="size-10 rounded-full border border-[#e7e3cf] dark:border-[#3d3a2a] flex items-center justify-center hover:bg-white dark:hover:bg-[#3d3a2a]">
              <span className="material-symbols-outlined">chevron_left</span>
            </button>
            <button className="size-10 rounded-full border border-[#e7e3cf] dark:border-[#3d3a2a] flex items-center justify-center hover:bg-white dark:hover:bg-[#3d3a2a]">
              <span className="material-symbols-outlined">chevron_right</span>
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Placeholder related items - keep static for now */}
          {[1, 2, 3, 4].map((n) => (
            <div key={n} className="group cursor-pointer">
              <div className="aspect-[4/5] rounded-xl overflow-hidden mb-4 relative">
                <img
                  alt={`Related ${n}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  src={product.imgVariants?.[n - 1] || product.imgVariants?.[0]}
                />
                <button className="absolute top-3 right-3 size-8 bg-white/80 backdrop-blur rounded-full flex items-center justify-center hover:bg-white text-background-dark">
                  <span className="material-symbols-outlined !text-xl">favorite</span>
                </button>
              </div>
              <h4 className="font-bold group-hover:text-primary transition-colors">{product.name} {n}</h4>
              <p className="text-sm text-[#9a8d4c] mb-2">${product.starting_price}</p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
